import { useBreakpoint } from "@/hooks/useBreakpoint";
import { Flags } from "@/providers/LaunchDarklyProvider";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useOnboardingRecord } from "./status";
import type { Stage } from "./types";

/**
 * The LaunchDarkly boolean and a desktop-sized layout: the tour runs on the
 * canvas, which is not built for phones, so below lg nothing offers, shows
 * or runs, and the record is left as it is for the next desktop visit.
 */
export function useOnboardingEnabled(): boolean {
  const flag = !!useFlags<Flags>().onboarding;
  const lg = useBreakpoint("lg");
  return flag && lg;
}

/** `off` when the flag is off, otherwise where the record says this user is. */
export function useOnboardingStage(): Stage {
  const enabled = useOnboardingEnabled();
  const { stage } = useOnboardingRecord();
  return enabled ? stage : "off";
}
